import authBaseAxios from "../utils/api";

export const SystemDefaultServices = {
  getDefaultTermsRule: (params?: Record<string, string>) => {
    return authBaseAxios.get("/suppliers/default-terms-rules", { params });
  },

  updateSystemDefaultTerm: (data: any): Promise<any> => {
    return authBaseAxios.post("suppliers/default-terms", data);
  },

  updateSystemDefaultRule: (data: any): Promise<any> => {
    return authBaseAxios.post("suppliers/default-rules", data);
  },

  updateSystemDefaultGeneralSetting: (data: any): Promise<any> => {
    return authBaseAxios.post("master-data/default-general-setting", data);
  },
};
